"use strict";
var flyd = require("flyd");
var filter = require("flyd/module/filter");
var Promise = require("promise");
var par = require("par");
var defer = par(require("promise-defer"), Promise);
var Platform = require("react-native").Platform;

var getBLE = require("./ble");
var getBluetoothLE = require("./bluetoothle");
var getBlePlx = require("./bluPlx");

module.exports = get;

function get() {
	var connected = flyd.stream();
	var disconnected = flyd.stream();
	var scanning = flyd.stream();
	var scanned = flyd.stream();
	var events = flyd.stream();
	var errors = flyd.stream();
	var loaded = flyd.stream();

	var isNative = Platform.OS !== "web";

	var adapterPromises = isNative ? {
		bluPlx: getBlePlx()
	} : {
		ble: getBLE(),
		bluetoothle: getBluetoothLE(),
	};

	var destroyed = false;
	var adapter = null;

	var loadedAdapters = 0;
	var methodQueue = [];

	Object.keys(adapterPromises).forEach(function(adapter){
			adapterPromises[adapter].then(handle_adapter).catch(handle_adapter_fail);
		});

	return {
		connected: connected,
		disconnected: disconnected,
		scanning: scanning,
		scanned: scanned,
		events: events,
		errors: errors,
		loaded: loaded,

		// General Methods
		on: on,
		destroy: destroy,

		// Bluetooth Methods
		connect: wrapPromise("connect"),
		disconnect: wrapPromise("disconnect"),
		scan: wrapInvoke("scan"),
		stopScan: wrapPromise("stopScan"),
		listen: wrapInvoke("listen"),
		poll: wrapInvoke("poll"),
		read: wrapPromise("read"),
		write: wrapPromise("write"),
		unlisten: wrapPromise("unlisten"),
		unpoll: wrapInvoke("unpoll"),
		enable: wrapPromise("enable"),
		disable: wrapPromise("disable"),

		// Method generation
		writer: makeWriter,
		reader: makeReader,
		listener: makeListener,
		poller: makePoller
	};

	function handle_adapter(resolvedAdapter) {
		adapter = resolvedAdapter;

		adapter.connected.map(connected);
		adapter.disconnected.map(disconnected);
		adapter.scanning.map(scanning);
		adapter.scanned.map(scanned);
		adapter.events.map(events);
		adapter.errors.map(errors);

		methodQueue.forEach(executeMethod);

		loaded(adapter.type);
	}

	function executeMethod(method) {
		var result = adapter[method.name].apply(adapter, method.arguments);

		if (method.deferred) {
			if (!result.then) return;
			result.then(method.deferred.resolve)
				.catch(method.deferred.reject);
		}
	}

	function handle_adapter_fail() {
		loadedAdapters += 1;
		if (loadedAdapters == 2)
			errors(new Error("No Valid Bluetooth Adapters Detected"));
	}

	function makeWriter(service, characteristic, value) {
		return par(wrapPromise("write"), service, characteristic, value);
	}

	function makeReader(service, characteristic) {
		return par(wrapPromise("read"), service, characteristic);
	}

	function makeListener(service, characteristic) {
		return par(wrapInvoke("listen"), service, characteristic);
	}

	function makePoller(time, characteristic, service) {
		return par(wrapInvoke("poll"), time, characteristic, service);
	}

	function wrapPromise(name) {
		return function () {
			if (adapter)
				return adapter[name].apply(adapter, arguments);

			var deferred = defer();
			methodQueue.push({
				name: name,
				arguments: arguments,
				deferred: deferred
			});

			return deferred.promise;
		};
	}

	function wrapInvoke(name) {
		return function () {
			if (adapter)
				return adapter[name].apply(adapter, arguments);

			methodQueue.push({
				name: name,
				arguments: arguments
			});

			return arguments[arguments.length - 1];
		};
	}

	function destroy() {
		if (destroyed) return Promise.resolve(new Error("Already destroyed"));
		destroyed = true;
		if (adapter) return adapter.destroy();
	}

	function on(characteristic) {
		if (destroyed) return;
		return filter(isType(characteristic), events);
	}
}

function isType(characteristic) {
	return function (event) {
		return event.characteristic === characteristic;
	};
}
